export default __webpack_public_path__ + "static/media/mullayangiri.a86040ae.jpg";